export enum TemplateFieldType {
    TEXT = "text",
    LONG_TEXT = "long_text",
    BOOLEAN = "boolean",
    SELECT = "select"
}

export interface TemplateField {
    id?: string;
    name: string;
    description: string;
    field_type: TemplateFieldType;
    order: number;
}

export interface SessionTemplate {
    id: string;
    name: string;
    description: string;
    therapist_id?: string;
    is_custom: boolean;
    fields: TemplateField[];
}

export interface SessionTemplateCreate {
    name: string;
    description?: string;
    fields: TemplateField[];
}

export interface SessionTemplateUpdate {
    name?: string;
    description?: string;
    fields?: TemplateField[];
}
